import { track } from '../../utils/analytics';
import { ANALYTICS } from '../../utils/consts/analytics';

export const FooterTracking = {
  trackView: () => {
    track({
      event: ANALYTICS.EVENTS.VIEWED_COMPONENT,
      data: {
        label: ANALYTICS.FOOTER_V2.COMPONENT,
      },
    });
  },
  trackLinkClick: (label: string) => {
    track({
      event: ANALYTICS.FOOTER_V2.LINK_CLICK,
      data: {
        label,
        component: ANALYTICS.FOOTER_V2.COMPONENT,
      },
    });
  },
  trackSocialMediaClick: (name: string) => {
    track({
      event: ANALYTICS.FOOTER_V2.SOCIAL_MEDIA_CLICK,
      data: {
        label: name,
        component: ANALYTICS.FOOTER_V2.COMPONENT,
      },
    });
  },
};
